/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SubmittedBriefResponse } from './';
import {
    SubmittedBriefResponseFromJSON,
    SubmittedBriefResponseFromJSONTyped,
    SubmittedBriefResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubmittedProposalsResponse
 */
export interface SubmittedProposalsResponse {
    /**
     * 
     * @type {Array<SubmittedBriefResponse>}
     * @memberof SubmittedProposalsResponse
     */
    briefs: Array<SubmittedBriefResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof SubmittedProposalsResponse
     */
    hasNextPage: boolean;
}

/**
 * Check if a given object implements the SubmittedProposalsResponse interface.
 */
export function instanceOfSubmittedProposalsResponse(value: object): value is SubmittedProposalsResponse {
    if (!('briefs' in value) || value['briefs'] === undefined) return false;
    if (!('hasNextPage' in value) || value['hasNextPage'] === undefined) return false;
    return true;
}

export function SubmittedProposalsResponseFromJSON(json: any): SubmittedProposalsResponse {
    return SubmittedProposalsResponseFromJSONTyped(json, false);
}

export function SubmittedProposalsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmittedProposalsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'briefs': ((json['briefs'] as Array<any>).map(SubmittedBriefResponseFromJSON)),
        'hasNextPage': json['hasNextPage'],
    };
}

export function SubmittedProposalsResponseToJSON(value?: SubmittedProposalsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'briefs': ((value['briefs'] as Array<any>).map((v) => SubmittedBriefResponseToJSON(v))),
        'hasNextPage': value['hasNextPage'],
    };
}

